import { selectFullHeaderHeightPx } from "@/store/slices/dashboardSlice";
import { clearSelectedIds, selectDrawerOpen, setDrawerOpen } from "@/store/slices/detailsDrawerSlice";
import { RootState, store } from "@/store/store";
import { Box, Drawer, SxProps, Theme, useMediaQuery, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

interface RightDrawerProps {
  stateName: string;
  width: string;
  shift?: boolean;
  sx?: SxProps<Theme>;
  padding?: string;
}

const RightDrawer = ({ width, shift, sx, padding, children }: PropsWithChildren<RightDrawerProps>) => {
  const theme = useTheme();
  const sm_down = useMediaQuery(theme.breakpoints.down("sm"));
  const open = useSelector((state: RootState) => selectDrawerOpen(state));
  const { id: selectedTab } = useParams();
  const location = useLocation();
  const basePath = location.pathname.split("/")[1];
  const fullDashboardHeaderHeight = useSelector(selectFullHeaderHeightPx);

  return sm_down ? (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        store.dispatch(setDrawerOpen({ value: false }));
        store.dispatch(clearSelectedIds({ page: basePath, tab: selectedTab }));
      }}
      sx={{
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          boxSizing: "border-box",
          ...(shift && { marginTop: [`${fullDashboardHeaderHeight}px`, "unset"] }),
          width: ["100%", "unset"],
          maxHeight: shift ? `calc(100vh - ${fullDashboardHeaderHeight}px)` : "100vh"
        },
        ...(sx && sx),
        zIndex: (theme) => [theme.zIndex.drawer - 1, theme.zIndex.drawer + 1]
      }}
      elevation={2}
    >
      <Box
        component="div"
        sx={{
          padding: padding ?? "1em",
          width: ["100%"],
          height: shift ? `calc(100vh - ${fullDashboardHeaderHeight}px)` : "100vh",
          maxHeight: shift ? `calc(100vh - ${fullDashboardHeaderHeight}px)` : "100vh"
        }}
      >
        {children}
      </Box>
    </Drawer>
  ) : (
    <Box
      component="div"
      sx={{
        width: width,
        height: "100%",
        ...(sx && sx),
        bgcolor: (theme: Theme) => theme.surface.low,
        padding: "0",
        borderRadius: "1em",
        display: open ? "box" : "none"
      }}
    >
      {children}
    </Box>
  );
};

export { RightDrawer };
export type { RightDrawerProps };
